export enum HttpObject {
    JSON = <any>"application/json",
    URLENCODE =  <any>"application/x-www-form-urlencoded",
    JAVASCRIPT = <any>"application/javascript",
    XML  = <any>"application/xml",
    AUTHTYPE = <any>"bearer",
    GRANTTYPE = <any>"password"
}



// WEBPACK FOOTER //
// ./src/app/shared/enum/http-object.enum.ts